import { Component } from '@angular/core'

import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    template: ` <div appAutoSize style="border: 1px solid lightgray">
        <iframe
            width="100%"
            height="100%"
            src="https://app.powerbi.com/reportEmbed?reportId=f7f7f573-e114-4deb-9d66-14544009d989&autoAuth=true&ctid=27c00eb3-08d1-4630-a0be-e2ae3bb5337c"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
    </div>`,
    standalone: true,
    imports: [AutoSizeDirective],
})
export class EquipmentReportComponent {}
